import * as configureSolarApi from '../store/configureSolarApi';

const vorhersageReducer = (state = {
    AktuelleVorhersageUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_AktuelleVorhersage_vorhersageReducer":
            return { ...state, AktuelleVorhersageUI: action.value, isLoaded: true };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default vorhersageReducer;
